import { CustomerGuestPlatform } from 'src/models/customer-guest.model';

export interface GuestPlatformBadge {
  label: string;
  icon: string | null;
}

/** Where a guest came from, as the guest list and the reservation guest picker show it. */
const GUEST_PLATFORM_BADGES: Record<Exclude<CustomerGuestPlatform, null>, GuestPlatformBadge> = {
  airbnb: { label: 'Airbnb', icon: 'assets/img/airbnb-logo.svg' },
  booking_com: { label: 'Booking.com', icon: 'assets/img/integration-images/booking-channel-green.svg' },
  vrbo: { label: 'Vrbo', icon: null },
  tidy: { label: 'Direct Booking', icon: 'assets/svg/globe-outline.svg' },
};

const ADDED_IN_TIDY: GuestPlatformBadge = {
  label: 'Added in TIDY',
  icon: 'assets/svg/person-add-outline.svg',
};

/**
 * A guest with no platform was added by hand. A platform this app does not know yet
 * shows its own name: a missing badge used to throw mid-render and blank the whole row.
 */
export function guestPlatformBadge(platform: CustomerGuestPlatform | string | null | undefined): GuestPlatformBadge {
  if (!platform) { return ADDED_IN_TIDY; }
  const known = GUEST_PLATFORM_BADGES[platform as Exclude<CustomerGuestPlatform, null>];
  if (known) { return known; }
  const name = String(platform).replace(/_/g, ' ');
  return { label: name.charAt(0).toUpperCase() + name.slice(1), icon: null };
}
